import { jsx as _jsx } from "react/jsx-runtime";
export const FormRow = (props) => (_jsx("div", { className: "form-row", children: props.children }));
